import { ApiRequestFilters } from '../../../shared/types/api-request-filters';

/**
 * Vehicle groups filters
 */
export class VehicleGroupsFilters extends ApiRequestFilters {}
